import axios from "axios";

import { RefLetterGenerationOptions } from "@/lib/referees/refLetterOptions";

interface CreateRefLetterFromDetailsParams {
  applicationId: string;
  refereeId: string;
  refereeName: string;
  generationOptions?: RefLetterGenerationOptions;
}

export const createRefLetterFromDetails = async ({
  applicationId,
  refereeId,
  refereeName,
  generationOptions,
}: CreateRefLetterFromDetailsParams) => {
  try {
    console.log(
      `📤 Creating ref letter: applicationId=${applicationId}, refereeId=${refereeId}, refereeName=${refereeName}`
    );
    const res = await axios.post(
      `/api/application/${applicationId}/google-doc/ref-letter`,
      {
        refereeId,
        refereeName,
        ...generationOptions,
      }
    );

    console.log("✅ Ref letter created successfully:", res.data);
    return res.data;
  } catch (error: any) {
    // eslint-disable-next-line no-console
    console.error("❌ Failed to create ref letter from details", error);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    return null;
  }
};
